"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateDateFormat = void 0;
const generateDateFormat = dateString => {
  const input = dateString.toLowerCase();
  let result = '';
  let usedDay = false;
  let usedMonth = false;
  let usedYear = false;
  let usedSeparator = false;
  for (const char of input) {
    if (char === 'd' && !usedDay) {
      result += 'dd';
      usedDay = true;
      usedSeparator = false;
    }
    if (char === 'm' && !usedMonth) {
      result += 'MM';
      usedMonth = true;
      usedSeparator = false;
    }
    if (char === 'y' && !usedYear) {
      result += 'yyyy';
      usedYear = true;
      usedSeparator = false;
    }
    if ((char === ' ' || char === '/' || char === '-' || char === '.') && !usedSeparator) {
      result += char;
      usedSeparator = true;
    }
  }
  return result.trim();
};
exports.generateDateFormat = generateDateFormat;
